/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalInfo
 */
export interface CarePrincipalInfo {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalInfo
     */
    id?: string;
}

export function CarePrincipalInfoFromJSON(json: any): CarePrincipalInfo {
    return CarePrincipalInfoFromJSONTyped(json, false);
}

export function CarePrincipalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function CarePrincipalInfoToJSON(value?: CarePrincipalInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

